import { GetTidbitsActionTypes } from "./types";
let INITIAL_STATE = {
  get_tidbits_loading: false,
  get_tidbits_error: null,
  get_tidbits_data: null,
};

export const getTidbitsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetTidbitsActionTypes.GET_TIDBITS_LOADING:
      return { ...state, get_tidbits_loading: true };
    case GetTidbitsActionTypes.GET_TIDBITS_SUCCESS:
      return {
        ...state,
        get_tidbits_loading: false,
        get_tidbits_data: action.payload,
      };
    case GetTidbitsActionTypes.GET_TIDBITS_ERROR:
      return {
        ...state,
        get_tidbits_loading: false,
        get_tidbits_error: action.payload,
      };
    default:
      return state;
  }
};
